import { createTheme } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import * as Sentry from '@sentry/nextjs'
import type { AppProps } from 'next/app'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import 'nprogress/nprogress.css'
import { useEffect, useState } from 'react'
import { Web3AuthProvider } from '../services/web3auth'
import useAuthStore from '../store/authStore'
import '../styles/globals.css'
import { LogError } from '../utils'
const BiconomyContextProvider = dynamic(
  () => import('../context/BiconomyProvider')
)
const ErrorBoundary = dynamic(() => import('../ErrorBoundary'))
const Layout = dynamic(() => import('./layout'))

const TopProgressBar = dynamic(
  () => {
    return import('../components/common/PageProgress')
  },
  { ssr: false }
)

const theme = createTheme({
  typography: {
    fontFamily: "'Lato', sans-serif",
  },

  palette: {
    type: 'dark',
    primary: {
      light: '#F3B35A',
      main: '#F1A240',
      dark: '#F4B45B',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
})

function MyApp({ Component, pageProps }: AppProps) {
  // Change web3AuthNetwork to  "mainnet" when on production
  // Chain can also be changed
  // Available options are in config folder

  const web3AuthNetwork = 'testnet'
  const chain = 'mumbai'
  const userInfo = useAuthStore((state) => state.userInfo)
  const [newAccount, setNewAccount] = useState<any>()
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: 'https://1438ac1794344f7e829f451cd27f423a@o1355891.ingest.sentry.io/6640765',
      debug: process.env.NODE_ENV !== 'production',
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    })
  }

  // use effect without deps array to make it run each time
  // whenever there is a change in metamask account
  useEffect(() => {
    const typeofLogin = localStorage.getItem('Web3Auth-cachedAdapter')
    const user_id = localStorage.getItem('uid')
    if (typeofLogin == 'metamask') {
      if (window.ethereum) {
        window.ethereum.on('accountsChanged', function (accounts: any) {
          if (user_id) {
            console.log('accountsChanges', accounts)
            setNewAccount(accounts[0])
          }
        })
      }
    }
  })

  const router = useRouter()

  return (
    // Using Web3auth functions globally
    <ThemeProvider theme={theme}>
      <Web3AuthProvider chain={chain} web3AuthNetwork={web3AuthNetwork}>
        <BiconomyContextProvider>
          <Layout>
            <CssBaseline />
            <ErrorBoundary>
              <TopProgressBar />
              <Component
                {...pageProps}
                logError={LogError}
                router={router}
                userInfo={userInfo}
                account={newAccount}
              />
            </ErrorBoundary>
          </Layout>
        </BiconomyContextProvider>
      </Web3AuthProvider>
    </ThemeProvider>
  )
}

export default MyApp
